import { reaction } from 'mobx';
import type { IStore } from '../Store';
import { addDisposer } from 'mobx-state-tree';

export const configureNegativeCountMonitor = (store: IStore) => {
  const onTotalChange = reaction(
    () => store.jobApplicationStore.total,
    () => {
      store.jobApplicationStore.fixOutOfSyncTotal();
    },
  );
  addDisposer(store, onTotalChange);
};
